<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">设置讲师</span>
        <el-form :inline="true">
          <el-form-item>
            <div style="width:99%;float:left">
              <el-input placeholder="请输入讲师名称" v-model="teachName" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchTea">搜索</el-button>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="open">添加</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deletesTea">批量删除</el-button>
            <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
          </el-form-item>
        </el-form>
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleTeaSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="UserName" show-overflow-tooltip label="账号"></el-table-column>
          <el-table-column prop="TeacherName" show-overflow-tooltip label="姓名"></el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span v-if="scope.row.Gender==0">男</span>
              <span v-else>女</span>
            </template>
          </el-table-column>
          <el-table-column prop="Mobile" show-overflow-tooltip label="手机号"></el-table-column>
          <el-table-column prop="IDNumber" show-overflow-tooltip label="身份证号"></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                class="el-icon-delete"
                @click="deleteTea(scope.row.Id)"
                titlt="删除"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          title="讲师列表"
          :visible.sync="dialogVisible"
          width="60%"
          :modal-append-to-body="false"
          :before-close="handleClose"
        >
          <el-form :inline="true" :model="formTea" class="demo-form-inline">
            <el-form-item label="讲师名称">
              <el-input v-model="formTea.teaName" placeholder="请输入讲师名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="teaList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" :selectable="checkboxInit"></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="DisplayName" show-overflow-tooltip label="姓名"></el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.Gender==0">男</span>
                <span v-else>女</span>
              </template>
            </el-table-column>
            <el-table-column prop="Mobile" show-overflow-tooltip label="手机号"></el-table-column>
            <el-table-column prop="IDNumber" show-overflow-tooltip label="身份证号"></el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addSetUpTeacher">确 定</el-button>
          </span>
          <el-pagination
            background
            class="wl-pagination-text"
            @size-change="handleSizeChange"
            @current-change="onPageChangeHandler"
            :current-page="pageIndex"
            :page-sizes="[10, 25, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            v-show="total>0"
          ></el-pagination>
        </el-dialog>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleTeaSizeChange"
          @current-change="onPageTeaChangeHandler"
          :current-page="pageTeaIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageTeaSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="teaTotal"
          v-show="teaTotal>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //待选择讲师列表
      teaList: [],
      formTea: {
        teaName: ""
      },
      //添加讲师id
      ids: [],
      //讲师列表
      list: [],
      //删除讲师id
      teaIds: [],
      //待选择列表
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      dialogVisible: false,
      //讲师列表
      pageTeaIndex: 1,
      pageTeaSize: 10,
      teaTotal: 0,
      teachName: ""
    };
  },
  props: {
    siteId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSetUpTeacherList();
  },
  methods: {
    /* 默认是否已选中 */
    checkboxInit(row, index) {
      return row.isAdd;
    },
    //返回上一级
    goBack() {
      this.$router.push({
        name: "adoptSchool"
      });
    },
    //查询带选择列表
    search() {
      this.getTeacherList(1);
    },
    //查询列表
    searchTea() {
      this.getSetUpTeacherList(1);
    },
    //获取讲师列表
    getSetUpTeacherList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SetUpManager/getSetUpTeacherList", {
          teacherName: this.teachName,
          page: page,
          PageSize: this.pageTeaSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.list = rst.list;
            that.teaTotal = rst.pagination.totalCount;
            that.pageTeaSize = rst.pagination.pageSize;
            that.pageTeaIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //添加讲师
    addSetUpTeacher() {
      var that = this;
      this.$http
        .post("/api/XOrg/SetUpManager/addSetUpTeacher", {
          siteId: this.siteId,
          teachIds: this.ids
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getSetUpTeacherList(1);
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //待选择讲师列表
    getTeacherList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SetUpManager/getTeacherList", {
          teacherName: this.formTea.teaName,
          page: page,
          PageSize: this.pageSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.teaList = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //批量删除讲师
    deletesTea() {
      debugger;
      var that = this;
      this.$confirm("此操作将批量删除讲师, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/SetUpManager/deleteSetUpTeacher", {
              ids: this.teaIds
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getSetUpTeacherList(1);
                that.$message.success(rst.msg);
              } else {
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //点击删除讲师
    deleteTea(id) {
      var that = this;
      this.$confirm("此操作将删除该讲师, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/SetUpManager/deleteSetUpTeacher", {
              ids: id
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getSetUpTeacherList(1);
                that.$message.success(rst.msg);
              } else {
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    handleTeaSelectionChange(val) {
      this.teaIds = [];
      val.forEach(element => {
        this.teaIds.push(element.Id);
      });
    },
    handleClose() {
      //关闭对话框
      this.dialogVisible = false;
    },
    open() {
      //弹出对话框
      this.dialogVisible = true;
      this.getTeacherList();
    },
    onPageChangeHandler(page) {
      this.getTeacherList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTeacherList(1);
    },
    onPageTeaChangeHandler(page) {
      this.getSetUpTeacherList(page);
    },
    handleTeaSizeChange(val) {
      this.pageSize = val;
      this.getSetUpTeacherList(1);
    }
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a {
    color: #fff;
    background: #409eff;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
